import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const ContentScrollable = styled.div`
  @media (min-width: ${breakpoints[3]}) {
    margin: 0 auto;
    padding-right: 0;
    padding-left: 0;
    max-width: 1166px;
    width: 100%;
  }
`;

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;
  overflow: auto;
  padding-right: 24px;
  padding-left: 24px;
  padding-bottom: 24px;
`;
